import { backendApi } from "./axios";
import { ADMIN_STUDENT_ENDPOINTS, ADMIN_VERIFICATION_REQUEST_ENDPOINTS, ADMIN_USER_ENDPOINTS, ADMIN_SETTINGS_ENDPOINTS, ADMIN_TUTOR_ENDPOINTS, ADMIN_STUDENT_REVIEWS_ENDPOINTS,ADMIN_INSTITUTE_ENDPOINTS, ADMIN_GRADE_MANAGEMENT_ENDPOINTS, ADMIN_DISCOUNT_ENDPOINTS } from "./endpoints";


// Admin Student API calls
export function getStudents(payload) {
    return backendApi.get(ADMIN_STUDENT_ENDPOINTS.GET_STUDENTS, { params: payload});
}
export function searchStudents(payload) {
    return backendApi.get(ADMIN_STUDENT_ENDPOINTS.SEARCH_STUDENTS, { params: payload});
}
export function updateStatus(studentId) {
    return backendApi.put(ADMIN_STUDENT_ENDPOINTS.UPDATE_STATUS.replace(':studentId', studentId));
}
export function exportStudents(payload) {
    return backendApi.get(ADMIN_STUDENT_ENDPOINTS.EXPORT_STUDENTS, {params: payload});
}
export function getStudentProfile(studentId) {
    return backendApi.get(ADMIN_STUDENT_ENDPOINTS.GET_STUDENT_PROFILE.replace(':studentId', studentId))
}
export function getStudentDetails(studentId) {
    return backendApi.get(ADMIN_STUDENT_ENDPOINTS.GET_STUDENT_DETAILS.replace(':studentId', studentId))
}
export function deleteStudents(payload) {
    return backendApi.delete(ADMIN_STUDENT_ENDPOINTS.DELETE_STUDENTS, {data: payload});
}
export function getEnrolledTutors(studentId) {
    return backendApi.get(ADMIN_STUDENT_ENDPOINTS.GET_ENROLLED_TUTORS.replace(':studentId', studentId));
}
export function getPreviousTutors(studentId) {
    return backendApi.get(ADMIN_STUDENT_ENDPOINTS.GET_PREVIOUS_TUTORS.replace(':studentId', studentId));
}



// Admin tutor API calls
export function getTutors(payload) {
    return backendApi.get(ADMIN_TUTOR_ENDPOINTS.GET_TUTORS, {params: payload});
}
export function searchTutors(payload) {
    return backendApi.get(ADMIN_TUTOR_ENDPOINTS.SEARCH_TUTORS, {params: payload});
}
export function updateTutorStatus(tutorId) {
    return backendApi.put(ADMIN_TUTOR_ENDPOINTS.UPDATE_STATUS.replace(':tutorId', tutorId));
}
export function exportTutors(payload) {
    return backendApi.get(ADMIN_TUTOR_ENDPOINTS.EXPORT_TUTORS, {params: payload});
}
export function getTutorProfile(tutorId) {
    return backendApi.get(ADMIN_TUTOR_ENDPOINTS.GET_TUTOR_PROFILE.replace(':tutorId', tutorId))
}
export function deleteTutors(payload) {
    return backendApi.delete(ADMIN_TUTOR_ENDPOINTS.DELETE_TUTORS, {data: payload});
}
export function getEnrolledStudents(tutorId) {
    return backendApi.get(ADMIN_TUTOR_ENDPOINTS.GET_ENROLLED_STUDENTS.replace(':tutorId', tutorId));
}
export function getPreviousStudents(tutorId) {
    return backendApi.get(ADMIN_TUTOR_ENDPOINTS.GET_PREVIOUS_STUDENTS.replace(':tutorId', tutorId));
}

// Admin Institute API calls
export function getInstitute(payload) {
    return backendApi.get(ADMIN_INSTITUTE_ENDPOINTS.GET_INSTITUTES, {params: payload});
}
export function searchInstitute(payload) {
    return backendApi.get(ADMIN_INSTITUTE_ENDPOINTS.SEARCH_INSTITUTES, {params: payload});
}
export function updateInstituteStatus(instituteId) {
    return backendApi.put(ADMIN_INSTITUTE_ENDPOINTS.UPDATE_STATUS.replace(':instituteId', instituteId));
}
export function exportInstitute(payload) {
    return backendApi.get(ADMIN_INSTITUTE_ENDPOINTS.EXPORT_INSTITUTES, {params: payload});
}
export function getInstituteProfile(instituteId) {
    return backendApi.get(ADMIN_INSTITUTE_ENDPOINTS.GET_INSTITUTES_PROFILE.replace(':instituteId', instituteId))
}
export function deleteInstitute(payload) {
    return backendApi.delete(ADMIN_INSTITUTE_ENDPOINTS.DELETE_INSTITUTES, {data: payload});
}
export function getInstituteEnrolledTutors(instituteId) {
    return backendApi.get(ADMIN_INSTITUTE_ENDPOINTS.GET_ENROLLED_TUTORS.replace(':instituteId', instituteId));
}


// Admin Verifcation Request API calls
export function getVerificationRequests(payload) {
    return backendApi.get(ADMIN_VERIFICATION_REQUEST_ENDPOINTS.GET_REQUESTS, {params: payload});
}
export function approveRequest(tutorId) {
    return backendApi.put(ADMIN_VERIFICATION_REQUEST_ENDPOINTS.APPROVE_VERIFICATION_REQUEST.replace(':tutorId', tutorId));
}
export function rejectRequest(tutorId, payload) {
    return backendApi.put(ADMIN_VERIFICATION_REQUEST_ENDPOINTS.REJECT_VERIFICATION_REQUEST.replace(':tutorId', tutorId), {data: payload});
}
export function getTutorProfileDetails(tutorId) {
    return backendApi.get(ADMIN_VERIFICATION_REQUEST_ENDPOINTS.GET_TUTOR_PROFILE.replace(':tutorId', tutorId))
}
export function updateInitialReview(tutorId) {
    return backendApi.put(ADMIN_VERIFICATION_REQUEST_ENDPOINTS.UPDATE_INITIAL_REVIEW.replace(':tutorId', tutorId));
}
export function updateDocumentVerification(tutorId) {
    return backendApi.put(ADMIN_VERIFICATION_REQUEST_ENDPOINTS.UPDATE_DOCUMENT_VERIFICATION.replace(':tutorId', tutorId));
}
export function updateBackgroundCheck(tutorId) {
    return backendApi.put(ADMIN_VERIFICATION_REQUEST_ENDPOINTS.UPDATE_BACKGROUND_CHECK.replace(':tutorId', tutorId));
}
export function updateFinalStatus(tutorId) {
    return backendApi.put(ADMIN_VERIFICATION_REQUEST_ENDPOINTS.UPDATE_FINAL_REVIEW.replace(':tutorId', tutorId));
}
export function exportVerificationRequests(payload) {
    return backendApi.get(ADMIN_VERIFICATION_REQUEST_ENDPOINTS.EXPORT_REQUESTS, {params: payload});
}

export const getTutorPayoutSummary = (params) => {
    return backendApi.get(ADMIN_TUTOR_ENDPOINTS.GET_PAYOUT_SUMMARY, { params });
};

export const getTutorPaymentHistory = (tutorId, params) => {
  return backendApi.get(ADMIN_TUTOR_ENDPOINTS.GET_PAYOUT_HISTORY.replace(':tutorId', tutorId), { params });
};

// Admin User API calls
export function getUsers(payload) {
    return backendApi.get(ADMIN_USER_ENDPOINTS.GET_USERS, {params: payload});
}
export function getAdmin(adminId) {
    return backendApi.get(ADMIN_USER_ENDPOINTS.GET_ADMIN.replace(':adminId', adminId));
}
export function updateAdminUsername(adminId, payload) {
    return backendApi.put(ADMIN_USER_ENDPOINTS.UPDATE_ADMIN_USERNAME.replace(':adminId', adminId),payload);
}
export function updateAdminEmail(adminId, payload) {
    return backendApi.put(ADMIN_USER_ENDPOINTS.UPDATE_ADMIN_EMAIL.replace(':adminId', adminId),payload);
}
export function updateAdminRole(adminId, payload) {
    return backendApi.put(ADMIN_USER_ENDPOINTS.UPDATE_ADMIN_ROLE.replace(':adminId', adminId),payload);
}
export function updateAdminStatus(adminId) {
    return backendApi.put(ADMIN_USER_ENDPOINTS.UPDATE_ADMIN_STATUS.replace(':adminId', adminId));
}
export function updateAdminPassword(adminId, payload) {
    return backendApi.put(ADMIN_USER_ENDPOINTS.UPDATE_ADMIN_PASSWORD.replace(':adminId', adminId), payload);
}
export function deleteAdmin(adminId) {
    return backendApi.delete(ADMIN_USER_ENDPOINTS.DELETE_ADMIN.replace(':adminId', adminId));
}


//Admin settingd API calls
export function updateUsername(payload) {
    return backendApi.put(ADMIN_SETTINGS_ENDPOINTS.UPDATE_ADMIN_USERNAME,payload);
}
export function updateEmail(payload) {
    return backendApi.put(ADMIN_SETTINGS_ENDPOINTS.UPDATE_ADMIN_EMAIL,payload)
}
export function updatePassword(payload) {
    return backendApi.put(ADMIN_SETTINGS_ENDPOINTS.UPDATE_ADMIN_PASSWORD,payload);
}


//Admin Student Review API calls
export function getReviews(payload) {
    return backendApi.get(ADMIN_STUDENT_REVIEWS_ENDPOINTS.GET_REVIEWS, {params: payload});
}
export function getReviewDetails(reviewId) {
    return backendApi.get(ADMIN_STUDENT_REVIEWS_ENDPOINTS.GET_REVIEW_DETAILS.replace(':reviewId', reviewId));
}
export function updateReview(reviewId, payload) {
    return backendApi.put(ADMIN_STUDENT_REVIEWS_ENDPOINTS.UPDATE_REVIEW.replace(':reviewId', reviewId),payload);
}
export function exportReviews(payload) {
    return backendApi.get(ADMIN_STUDENT_REVIEWS_ENDPOINTS.EXPORT_REVIEWS, {params: payload});
}

// Admin Grade Management API calls
export function getGrades(params) {
  return backendApi.get(ADMIN_GRADE_MANAGEMENT_ENDPOINTS.GET_ALL, { params });
}

export function createGrade(payload) {
  return backendApi.post(ADMIN_GRADE_MANAGEMENT_ENDPOINTS.CREATE, payload);
}

export function updateGrade(gradeId, payload) {
  return backendApi.put(ADMIN_GRADE_MANAGEMENT_ENDPOINTS.UPDATE.replace(':gradeId', gradeId), payload);
}

export function deleteGrade(payload) {
  return backendApi.delete(ADMIN_GRADE_MANAGEMENT_ENDPOINTS.DELETE, { data: payload });
}

export function deleteSubject(payload, gradeId) {
  return backendApi.delete(ADMIN_GRADE_MANAGEMENT_ENDPOINTS.DELETE_SUBJECT.replace(':gradeId', gradeId), payload);
}

export function exportGrades() {
  return backendApi.get(ADMIN_GRADE_MANAGEMENT_ENDPOINTS.EXPORT_GRADES);
}

// Admin Discount API calls
export function getAllDiscounts() {
  return backendApi.get(ADMIN_DISCOUNT_ENDPOINTS.GET_ALL);
}

export function createDiscount(payload) {
  return backendApi.post(ADMIN_DISCOUNT_ENDPOINTS.CREATE, payload);
}

export function updateDiscount(id, payload) {
  return backendApi.put(ADMIN_DISCOUNT_ENDPOINTS.UPDATE.replace(':id', id), payload);
}

export function toggleDiscount(id) {
  return backendApi.patch(ADMIN_DISCOUNT_ENDPOINTS.TOGGLE.replace(':id', id));
}